import { render, staticRenderFns } from "./StatisticOnSpecialUser.vue?vue&type=template&id=6ec34c25"
import script from "./StatisticOnSpecialUser.vue?vue&type=script&lang=js"
export * from "./StatisticOnSpecialUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports